var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ScamAlert',{attrs:{"kycOrgCode":_vm.kycOrgCode,"kycOrgId":_vm.kycOrgId,"language":_vm.$i18n.locale,"isApp":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }